export default "__VITE_ASSET__RyLM69sB__"